<template>
  <main id="authorClients" v-if="isAuthed">
    <Toolbars ref="toolbars"
      :status="getStatus"
      :authors="store.authors"
      @emit="emitted"
    />
    <v-list dense class="py-0 transparent clients body" :three-line="!$vuetify.breakpoint.smAndUp">
      <v-list-item class="px-0 mx-3" v-if="$vuetify.breakpoint.smAndUp">
        <v-row>
          <v-col cols="2" class="primary pa-1">
            <v-btn depressed tile block class="body-1 pa-0 primary blue-grey--text text--darken-3" @click="order('id')">
              <span :class="[ 'font-weight-bold', { caption: $vuetify.breakpoint.smAndDown } ]">企業ID</span>
              <span v-if="printOrderField === 'id'">
                <v-icon small>{{ printOrderDirectionIcon }}</v-icon>
              </span>
            </v-btn>
          </v-col>
          <v-col cols="5" class="primary pa-1">
            <v-btn depressed tile block class="body-1 pa-0 primary blue-grey--text text--darken-3" @click="order('name')">
              <span :class="[ 'font-weight-bold', { caption: $vuetify.breakpoint.smAndDown } ]">名前</span>
              <span v-if="printOrderField === 'name'">
                <v-icon small>{{ printOrderDirectionIcon }}</v-icon>
              </span>
            </v-btn>
          </v-col>
          <v-col cols="5" class="primary pa-1">
            <v-btn depressed tile block class="body-1 pa-0 primary blue-grey--text text--darken-3" @click="order('kana')">
              <span :class="[ 'font-weight-bold', { caption: $vuetify.breakpoint.smAndDown } ]">ふりがな</span>
              <span v-if="printOrderField === 'kana'">
                <v-icon small>{{ printOrderDirectionIcon }}</v-icon>
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-list-item>
      <v-progress-linear indeterminate class="px-0" :color="isLoading ? 'secondary' : 'transparent'"></v-progress-linear>
      <template v-for="item in getCompanyItems">
        <v-list-item class="px-0 it-hv mx-3" :key="item.id" :to="`../client/${item.id}`" target="_blank">
          <v-row v-if="$vuetify.breakpoint.smAndUp">
            <v-col cols="2" :class="[ 'text-center text-truncate', { caption: $vuetify.breakpoint.smAndDown } ]">{{ item.id }}</v-col>
            <v-col cols="5" :class="[ 'text-center text-truncate', { caption: $vuetify.breakpoint.smAndDown } ]">{{ item.name }}</v-col>
            <v-col cols="5" :class="[ 'text-center text-truncate', { caption: $vuetify.breakpoint.smAndDown } ]">{{ item.kana }}</v-col>
          </v-row>
          <v-list-item-content v-else>
            <v-list-item-subtitle class="caption">{{ item.kana }}</v-list-item-subtitle>
            <v-list-item-title class="body-1">{{ item.name  }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="item.id + '_div'"></v-divider>
      </template>
    </v-list>
  </main>
</template>

<script>
import Toolbars from './toolbars'

const DEFAULT = {
  LOADING: false,
  FILTERED: false,
  LIMIT: 20,
  ORDER: {
    FIELD: 'id',
    DIR: 'desc'
  }
}
const ICONS = {
  ORDER: {
    DIR: {
      ASC: ['fal', 'sort-numeric-down'],
      DESC: ['fal', 'sort-numeric-up']
    }
  }
}
export default {
  name: 'authorCompanies',
  components: {
    Toolbars
  },
  data () {
    return {
      config: {
        status: {
          authed: false,
          loading: DEFAULT.LOADING,
          filtered: DEFAULT.FILTERED
        }
      },
      meta: {
        authors: {}
      },
      form: {
        order: {
          field: DEFAULT.ORDER.FIELD,
          dir: DEFAULT.ORDER.DIR,
          icon: ICONS.ORDER.DIR[DEFAULT.ORDER.DIR.toUpperCase()]
        }
      },
      store: {
        clients: [],
        authors: {}
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.get()
  },
  methods: {
    init: function () {
      this.auth()
      this.$set(this.meta, 'authors', this.$store.getters['config/get']('authors'))
    },
    emitted: function (req) {
      const { action, data } = req || {}
      if (action && typeof this[action] === 'function') {
        this[action](data)
      }
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (fm) {
      if (fm) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}clients/get/items`, {
            id: fm.id,
            type: [ 'company' ],
            primary: fm.primary,
            limit: JSON.stringify({
              offset: fm.page,
              size: fm.limit
            }),
            order: JSON.stringify({
              field: this.form.order.field,
              dir: this.form.order.dir
            })
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$set(this.store, 'clients', res.data.data.clients)
              this.$refs.toolbars.count(res.data.data.count)
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    order: function (field) {
      if (field !== this.form.order.field) {
        this.$set(this.form.order, 'dir', DEFAULT.ORDER.DIR)
        this.$set(this.form.order, 'icon', ICONS.ORDER.DIR[DEFAULT.ORDER.DIR.toUpperCase()])
      } else {
        if (this.form.order.dir === 'asc') {
          this.$set(this.form.order, 'dir', 'desc')
          this.$set(this.form.order, 'icon', ICONS.ORDER.DIR.DESC)
        } else if (this.form.order.dir === 'desc') {
          this.$set(this.form.order, 'dir', 'asc')
          this.$set(this.form.order, 'icon', ICONS.ORDER.DIR.ASC)
        }
      }
      this.$set(this.form.order, 'field', field)
      this.$nextTick(() => {
        let fm = this.$refs.toolbars.getForm()
        this.get(fm)
      })
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    },
    isLoading () {
      return this.config.status.loading
    },
    isClientEmpty () {
      return (Object.keys(this.store.clients).length === 0)
    },
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    },
    printOrderField () {
      return this.form.order.field
    },
    printOrderDirectionIcon () {
      return this.$mango.order.icons.dir[this.form.order.dir] ? this.$mango.order.icons.dir[this.form.order.dir] : ''
    },
    getStatus () {
      return this.config.status
    },
    getCompanyItems () {
      return this.store.clients.length ? this.store.clients.map(it => {
        return it
      }) : []
    }
  }
}
</script>
